<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <base-material-card
      color="bgTemperature"
      icon="mdi-alert"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>
      <v-row>
        <v-col
          cols="12"
          md="12"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto"
            :label="$t('search')"
            hide-details
            single-line
            style="max-width: 250px;"
          />
        </v-col>
      </v-row>

      <v-divider class="mt-3" />

      <v-data-table
        :headers="localizationHeaders"
        :items="items"
        :search.sync="search"
        :sort-by="['name']"
        :sort-desc="[false]"
        :loading="loading"
      >
        <template v-slot:item.name="{ item }">
          <router-link :to="{ name: 'alert', params: { id: item.id }}">
            {{ item.name }}
          </router-link>
        </template>
        <template v-slot:item.active="{ item }">
          {{ booleanFormat(item.active) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
          >
            <v-icon @click="editAlert(item.id)">
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>
<style>
.bgTemperature{
  background-color: #023A66 !important;
}
</style>
<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const targetAlertsRespository = repositoryFactory.get('targetAlerts')

  export default {
    name: 'TargetAlerts',
    mixins: [filters],
    data: () => ({
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('activeTargetAlerts')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.targetAlerts.description'),
            value: 'description',
          },
          {
            text: this.$t('tables.targetAlerts.active'),
            value: 'active',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      var self = this
      self.loading = true
      targetAlertsRespository.getCurrentAlerts().then(response => {
        if (response.data.isValid) {
          self.items = response.data.data
        } else {
          self.showErrorMessage = true
          self.errorMessage = response.data.errorMessages[0]
        }
        self.loading = false
      }).catch(err => {
        self.showErrorMessage = true
        if (err.response.status === 400) {
          self.showErrorMessage = err.response.data.errorMessages[0]
        } else {
          self.errorMessage = err
        }
        self.loading = false
      })
    },
    methods: {
      editAlert (id) {
        this.$router.push({ name: 'alert', params: { id: id } })
      },
    },
  }
</script>
